/* eslint-disable react/no-danger */
import * as React from 'react';
import * as DOMPurify from 'dompurify';
import markdown from '../../utils/markdown';

type MarkdownHTMLProps = {
  className?: string;
  content: string;
};

function MarkdownHTML({ className, content }: MarkdownHTMLProps) {
  const cleanContent = DOMPurify.sanitize(content);

  return (
    <div
      className={`markdown ${className}`}
      dangerouslySetInnerHTML={{
        __html: markdown(cleanContent),
      }}
    />
  );
}

MarkdownHTML.defaultProps = {
  className: '',
};
export default MarkdownHTML;
